<template>
  <div class="cpl-Wrapper">
    <AppIcon class="cpl-EmptyImage" height="240" icon-name="empty-state-hero" width="424" />
    <AppTitle :level="5" disable-margin>
      <i18n-t
        class="cpl-Title"
        keypath="confluence.permission_less.title"
        scope="global"
        tag="div"
      />
    </AppTitle>
    <AppTitle :level="6" disable-margin>
      <i18n-t
        class="cpl-Description"
        keypath="confluence.permission_less.description"
        scope="global"
        tag="div"
      />
    </AppTitle>
  </div>
</template>

<script setup>
import AppIcon from '@/components/ui/AppIcon/AppIcon'
import AppTitle from '@/components/ui/AppTitle/AppTitle'

defineOptions({
  name: 'ConfluencePermissionLess'
})
</script>

<style lang="scss" scoped>
.cpl-Title {
  text-align: center;
  margin-bottom: 9px;
}
.cpl-Wrapper {
  text-align: center;
}
.cpl-EmptyImage {
  margin-bottom: 32px;
}
</style>
